export const CARD_TITLES = {
  INCOMING_BAG: "Incoming",
  INCOMING_BAGS: "Incoming",
  OUTSCAN_BAG: "Outscan",
  OUTSCAN_BAGS: "Outscan",
  AVAILABLE_BAG: "Available",
  AVAILABLE_BAGS: "Available",
  
  INCOMING_SHIPMENT: "Incoming",
  INCOMING_SHIPMENTS: "Incoming",
  OUTSCAN_SHIPMENT: "Outscan",
  OUTSCAN_SHIPMENTS: "Outscan",
  OUTSCAN_TO_CP_SHIPMENT: "Outscan To CP",
  OUTSCAN_TO_CP_SHIPMENTS: "Outscan To CP",
  AVAILABLE_SHIPMENT: "Available",
  AVAILABLE_SHIPMENTS: "Available",
  
  LIVE_SHIPMENTS: "Live Shipments",
  OVERDUE_SHIPMENTS: "Overdue (3+ Days) Shipments",
  LIVE_BAGS: "Live Bags",
  OVERDUE_BAGS: "Overdue (3+ Days) Bags",
};

export const VALID_MODAL_TITLES = [
  CARD_TITLES.INCOMING_BAG, CARD_TITLES.INCOMING_BAGS,
  CARD_TITLES.OUTSCAN_BAG, CARD_TITLES.OUTSCAN_BAGS,
  CARD_TITLES.OUTSCAN_TO_CP_SHIPMENT, CARD_TITLES.OUTSCAN_TO_CP_SHIPMENTS,
  CARD_TITLES.AVAILABLE_SHIPMENT, CARD_TITLES.AVAILABLE_SHIPMENTS,
  CARD_TITLES.OUTSCAN_SHIPMENT, CARD_TITLES.OUTSCAN_SHIPMENTS,
  CARD_TITLES.INCOMING_SHIPMENT, CARD_TITLES.INCOMING_SHIPMENTS,
  CARD_TITLES.AVAILABLE_BAG, CARD_TITLES.AVAILABLE_BAGS,
];
import React from "react";
import moment from "moment";

export const incomingBagsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "date", key: "date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Bag Number",
    dataIndex: "bag_number",
    key: "bag_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Bag Type", dataIndex: "bag_type", key: "bag_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Shipments", dataIndex: "shipments", key: "shipments", render: (text) => text || text === 0 ? text : "---" },
  { title: "Origin Hub", dataIndex: "origin_hub_name", key: "origin_hub_name", render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destination_hub_name", key: "destination_hub_name", render: (text) => text || text === 0 ? text : "---" },
  { title: "Weight", dataIndex: "bag_weight", key: "bag_weight", render: (text) => text || text === 0 ? text : "---" },
  { title: "Transport Mode", dataIndex: "transport_mode", key: "transport_mode", render: (text) => text || text === 0 ? text : "---" },
];

export const outscanBagsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "date", key: "date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Bag Number",
    dataIndex: "bag_number",
    key: "bag_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Bag Type", dataIndex: "bag_type", key: "bag_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Shipments", dataIndex: "shipments", key: "shipments", render: (text) => text || text === 0 ? text : "---" },
  { title: "Origin Hub", dataIndex: "origin_hub", key: "origin_hub", render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destination_hub_name", key: "destination_hub_name", render: (text) => text || text === 0 ? text : "---" },
  { title: "Weight", dataIndex: "weight", key: "weight", render: (text) => text || text === 0 ? text : "---" },
  { title: "Transport Mode", dataIndex: "transport_mode", key: "transport_mode", render: (text) => text || text === 0 ? text : "---" },
];

export const outscanToCPShipmentsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "date", key: "date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Shipment Number",
    dataIndex: "awb_number",
    key: "awb_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "From Hub", dataIndex: "from_hub", key: "from_hub", render: (text) => text || text === 0 ? text : "---" },
  { title: "To CP", dataIndex: "to_cp", key: "to_cp", render: (text) => text || text === 0 ? text : "---" },
];

export const inscanBagsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Inscan Date", dataIndex: "inscan_date", key: "inscan_date", width: 160, render: (text) => text ? moment(text).format("DD-MM-YYYY HH:mm") : "---" },
  {
    title: "Bag Number",
    dataIndex: "bag_number",
    key: "bag_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Inscan Hub", dataIndex: "inscan_hub", key: "inscan_hub", width: 250, render: (text) => text || text === 0 ? text : "---" },
  { title: "Origin Hub", dataIndex: "origin_hub", key: "origin_hub", width: 250, render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destination_hub", key: "destination_hub", width: 250, render: (text) => text || text === 0 ? text : "---" },
  { title: "Inscanned By", dataIndex: "inscanned_by", key: "inscanned_by", width: 200, render: (text) => text || text === 0 ? text : "---" },
  { title: "Bag Weight", dataIndex: "bag_weight", key: "bag_weight", render: (text) => text || text === 0 ? text : "---" },
  { title: "Content Type", dataIndex: "content_type", key: "content_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Mode", dataIndex: "mode", key: "mode", render: (text) => text || text === 0 ? text : "---" },
  { title: "Travel By", dataIndex: "travel_by", key: "travel_by", render: (text) => text || text === 0 ? text : "---" },
  { title: "Shipment Count", dataIndex: "shipment_count", key: "shipment_count", render: (text) => text || text === 0 ? text : "---" },
];

export const inscanShipmentsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "operation_date", key: "operation_date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Shipment Number",
    dataIndex: "awb_number",
    key: "awb_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Hub Name", dataIndex: "hub_name", key: "hub_name", render: (text) => text || text === 0 ? text : "---" },
  { title: "Service Type", dataIndex: "service_type", key: "service_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Doc Type", dataIndex: "doc_type", key: "doc_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Travel Type", dataIndex: "travel_type", key: "travel_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Booking CP Name", dataIndex: "booking_cp_name", key: "booking_cp_name", render: (text) => text || text === 0 ? text : "---" },
];

export const outscanShipmentsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "operation_date", key: "operation_date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Shipment Number",
    dataIndex: "awb_number",
    key: "awb_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Origin Hub", dataIndex: "origin_hub", key: "origin_hub", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Current Hub", dataIndex: "current_hub", key: "current_hub", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destination_hub_name", key: "destination_hub_name", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Doc Type", dataIndex: "doctype", key: "doctype", render: (text) => text || text === 0 ? text : "---" },
  { title: "Service Type", dataIndex: "service_type", key: "service_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Mode", dataIndex: "mode", key: "mode", render: (text) => text || text === 0 ? text : "---" },
  { title: "Status", dataIndex: "status", key: "status", render: (text) => text || text === 0 ? text : "---" },
];

export const incomingShipmentsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Booking Complete Time", dataIndex: "booking_complete_time", key: "booking_complete_time", width: 200, render: (text) => text ? <span style={{ whiteSpace: "nowrap" }}>{moment(text).format("DD-MM-YYYY HH:mm")}</span> : "---" },
  { title: "Date", dataIndex: "operation_date", key: "operation_date", width: 150, render: (text) => text ? <span style={{ whiteSpace: "nowrap" }}>{moment(text).format("DD-MM-YYYY")}</span> : "---" },
  {
    title: "Shipment Number",
    dataIndex: "awb_number",
    key: "awb_number",
    width: 180,
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Doc Type", dataIndex: "doc_type", key: "doc_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Mode", dataIndex: "mode", key: "mode", render: (text) => text || text === 0 ? text : "---" },
  { title: "Origin Hub", dataIndex: "originhub", key: "originhub", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "State", dataIndex: "state", key: "state", width: 160, render: (text) => text || text === 0 ? text : "---" },
  { title: "Zone", dataIndex: "zone", key: "zone", render: (text) => text || text === 0 ? text : "---" },
  { title: "Current Center", dataIndex: "current_center_name", key: "current_center_name", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destinationhub", key: "destinationhub", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Status", dataIndex: "status", key: "status", width: 180, render: (text) => text || text === 0 ? text : "---" },
  { title: "Booking Type", dataIndex: "booking_type", key: "booking_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Service Type", dataIndex: "service_type", key: "service_type", render: (text) => text || text === 0 ? text : "---" },
];

export const ERROR_MESSAGES = {
  NO_PATTERN_FOUND: "No pattern found in response",
  ERROR_PARSING_ACTIVE_HUB: "Error parsing active_hub",
  ERROR_FETCHING_DASHBOARD_DATA: "Error fetching dashboard data",
};

export const cardStyles = {
  incoming: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#175EB6",
  },
  inscan: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#008000",
  },
  pending: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#E28904",
  },
  outscan: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#353535",
  },
  pendingInscan: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#111827",
  },
  pendingOutscan: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#111827",
  },
};
